import { render, staticRenderFns } from "./editnumber.vue?vue&type=template&id=64e7ab34"
import script from "./editnumber.vue?vue&type=script&lang=js"
export * from "./editnumber.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports